import Ingress from "src/components/richtext/Ingress";
import MainText from "src/components/richtext/MainText";
import { type StreamingContent } from "src/lib/movieinfo/movieinfotypes";
import { IFilmomtale } from "src/lib/types/Filmomtale";
import styles from "./FilmTexts.module.css";

//#region [Props]
type FilmTextsProps = {
	cmsDocument?: IFilmomtale | null;
	streamingData?: StreamingContent | null;
	isStreamingContext?: boolean;
};
//#endregion

//#region [Component]
export default function FilmTexts({ cmsDocument, streamingData, isStreamingContext = false }: FilmTextsProps) {
	let hasCmsText = (cmsDocument?.ingress?.length ?? 0) > 0 || (cmsDocument?.bodyText?.length ?? 0) > 0;
	let hasStreamingText = streamingData?.synopsisIngress || streamingData?.synopsisBodyText;
	let useCmsText = !isStreamingContext;

	if (!hasStreamingText && hasCmsText) {
		useCmsText = true;
	}
	if (hasStreamingText && !hasCmsText) {
		useCmsText = false;
	}

	if (hasStreamingText && hasCmsText && isStreamingContext) {
		useCmsText = false;
	}

	if (!hasCmsText && !hasStreamingText) {
		return null;
	}

	return <div className={styles.text}>
		{useCmsText && <>
			<Ingress ingress={cmsDocument!.ingress} />
			<MainText mainText={cmsDocument!.bodyText} />
		</>}
		{!useCmsText && <>
			{streamingData?.synopsisIngress && <div className={styles.streamingIngress}>
				<p className={styles.preserveWhiteSpaceParagraph}>{streamingData.synopsisIngress}</p>
			</div>}
			{streamingData?.synopsisBodyText && <div className={styles.streamingBodyText}>
				<p className={styles.preserveWhiteSpaceParagraph}>{streamingData.synopsisBodyText}</p>
			</div>}
		</>}

	</div>;
}
//#endregion

